// extracted by mini-css-extract-plugin
module.exports = {"background":"bl_fB","shopping__wrapper__examples":"bl_fC","active":"bl_fD","shopping__wrapper__project":"bl_fF"};